import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { switchLanguage } from '../reducers/language/languageActions';
import { selectSelectedLanguage } from '../reducers/language/languageSelectors';

export const useLanguageSelector = () => {
  const { i18n } = useTranslation('auth');
  const dispatch = useDispatch();
  const locale = useSelector(selectSelectedLanguage);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const languageWrapperRef = useRef(null);

  // Sync i18n language with Redux locale
  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen(prev => !prev);
  };

  const handleLanguageSelect = nextLocale => {
    i18n.changeLanguage(nextLocale);
    dispatch(switchLanguage(nextLocale));
    setIsLanguageMenuOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (languageWrapperRef.current && !languageWrapperRef.current.contains(event.target)) {
        setIsLanguageMenuOpen(false);
      }
    };

    if (isLanguageMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLanguageMenuOpen]);

  return {
    locale,
    isLanguageMenuOpen,
    languageWrapperRef,
    toggleLanguageMenu,
    handleLanguageSelect,
  };
};
